export default function isHtml(string: string) {
  return !!string && /<\/?[a-z][\s\S]*>/i.test(string)
}
